// Mock data for AimFlex website

export const mockData = {
  // Company Information
  company: {
    name: 'Aim Flex',
    tagline: 'Your Vision, Our Canvas',
    description: 'Delivering High-Quality Signage Solutions',
    established: '1997',
    location: 'Madurai, Tamil Nadu',
    experience: '25+ years',
    mission: 'To provide the best service without compromising quality and time'
  },

  // Contact Information
  contact: {
    phone: '+91 9943281483',
    email: 'info@aimscreenprints.com',
    whatsapp: '+91 9943281483',
    address: {
      street: '34, EMS Nagar',
      area: 'Ponmeni, Bye Pass Road',
      city: 'Madurai',
      state: 'Tamil Nadu',
      pincode: '625016'
    },
    fullAddress: '34, EMS Nagar, Ponmeni, Bye Pass Road, Madurai. Tamil Nadu 625016, India',
    googleMapsLink: 'https://share.google/W5WaQEr5juLVAd1px',
    businessHours: 'Mon-Sat 9AM-7PM'
  },

  // Services Data
  services: [
    {
      id: 1,
      name: 'Flex Printing',
      shortDescription: 'Vibrant flex printing solutions',
      fullDescription: 'High-quality flex printing for indoor and outdoor banners, event backdrops, promotional displays, and festival decorations.',
      features: [
        'High-resolution printing up to 1440 DPI',
        'Weather-resistant materials',
        'Custom sizes up to 16 feet width',
        'Fade-resistant inks',
        'Same-day service available'
      ],
      applications: ['Banners', 'Event Backdrops', 'Promotional Displays', 'Festival Decorations'],
      priceRange: '₹50-200 per sq ft'
    },
    {
      id: 2,
      name: 'Vinyl Printing',
      shortDescription: 'Durable vinyl printing solutions',
      fullDescription: 'Premium vinyl printing for vehicle graphics, window decals, wall stickers, floor graphics, and reflective signage.',
      features: [
        'Premium vinyl materials',
        'Eco-solvent printing',
        'Lamination options available',
        'Cut-to-shape services',
        'Long-lasting durability (5+ years)'
      ],
      applications: ['Vehicle Wraps', 'Window Graphics', 'Wall Decals', 'Floor Graphics'],
      priceRange: '₹80-300 per sq ft'
    },
    {
      id: 3,
      name: 'Frame Welding',
      shortDescription: 'Custom frame welding services',
      fullDescription: 'Professional welding services for MS steel frames, aluminum structures, LED signage frames, and custom mounting solutions.',
      features: [
        'In-house welding expertise',
        'MS steel and aluminum fabrication',
        'Powder coating finish',
        'Rust-resistant treatment',
        'Custom dimensions available'
      ],
      applications: ['LED Frames', 'Signage Structures', 'Mounting Supports', 'Display Stands'],
      priceRange: '₹200-1000 per kg'
    },
    {
      id: 4,
      name: 'Signage Installation',
      shortDescription: 'Professional installation services',
      fullDescription: 'Complete signage installation with safety compliance, electrical connections, structural mounting, and project management.',
      features: [
        'Experienced installation team',
        'Safety equipment and protocols',
        'Site survey and planning',
        'Electrical connections for LED signs',
        'Post-installation support'
      ],
      applications: ['Building Signage', 'Rooftop Installations', 'Interior Branding', 'LED Displays'],
      priceRange: '₹500-5000 per installation'
    }
  ],

  // Portfolio Projects
  portfolio: [
    {
      id: 1,
      title: 'HD Automotive Car Detailing Studio',
      category: 'Shop Signage',
      client: 'HD Automotive',
      description: 'Complete branding solution for automotive service center including storefront signage, LED displays, and interior branding.',
      services: ['Flex Printing', 'Frame Welding', 'Installation'],
      completionDate: 'March 2024',
      location: 'Madurai, TN'
    },
    {
      id: 2,
      title: 'Flaming Kitchen Restaurant Signage',
      category: 'Flex Printing',
      client: 'Flaming Kitchen',
      description: 'Vibrant menu boards and promotional banners for restaurant chain with weather-resistant materials.',
      services: ['Flex Printing', 'Vinyl Graphics'],
      completionDate: 'February 2024',
      location: 'Chennai, TN'
    },
    {
      id: 3,
      title: 'Corporate Vehicle Wrapping Campaign',
      category: 'Vehicle Wraps',
      client: 'Delivery Express',
      description: 'Fleet branding for logistics company with full vehicle wraps and corporate branding elements.',
      services: ['Vinyl Printing', 'Vehicle Graphics'],
      completionDate: 'January 2024',
      location: 'Coimbatore, TN'
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: 'Rajesh Kumar',
      designation: 'Owner',
      company: 'Kumar Electronics',
      rating: 5,
      text: 'AimFlex transformed our storefront completely! The quality of their flex printing and the professional installation exceeded our expectations.',
      location: 'Madurai, TN'
    },
    {
      id: 2,
      name: 'Priya Sharma',
      designation: 'Marketing Manager',
      company: 'Tech Solutions Inc',
      rating: 5,
      text: 'Outstanding service and attention to detail. Our office signage looks amazing and has significantly improved our brand visibility.',
      location: 'Chennai, TN'
    },
    {
      id: 3,
      name: 'Mohammed Asif',
      designation: 'Restaurant Owner',
      company: 'Spice Garden',
      rating: 5,
      text: 'The team at Aim Flex delivered our restaurant signage on time and within budget. Highly professional and creative work.',
      location: 'Coimbatore, TN'
    }
  ],

  // Statistics
  stats: [
    { label: 'Happy Clients', value: '500+' },
    { label: 'Projects Completed', value: '1000+' },
    { label: 'Years of Experience', value: '25+' },
    { label: 'Team Members', value: '15+' }
  ],

  // FAQ Data
  faqs: [
    {
      question: 'What types of printing services do you offer?',
      answer: 'We offer flex printing, vinyl printing, digital printing, and large format printing for various applications including banners, vehicle graphics, signage, and promotional materials.'
    },
    {
      question: 'How long does it take to complete a signage project?',
      answer: 'Project timelines vary based on complexity. Simple flex banners can be completed same-day, while complex signage installations may take 3-7 days. We provide detailed timelines during consultation.'
    },
    {
      question: 'Do you provide installation services?',
      answer: 'Yes, we have an experienced installation team that handles everything from simple banner mounting to complex LED signage installations with proper safety protocols.'
    },
    {
      question: 'What is your service area?',
      answer: 'We primarily serve Madurai and surrounding areas, but we also take projects across Tamil Nadu for larger installations and corporate clients.'
    },
    {
      question: 'Can you help with design and artwork?',
      answer: 'Absolutely! Our design team can create custom artwork, logos, and layouts. We also accept client-provided designs and can make necessary adjustments for optimal printing results.'
    }
  ],

  // Process Steps
  process: [
    {
      step: 1,
      title: 'Consultation',
      description: 'We discuss your requirements, budget, and timeline to create the perfect solution for your needs.'
    },
    {
      step: 2,
      title: 'Design & Approval',
      description: 'Our design team creates mockups and designs for your approval before moving to production.'
    },
    {
      step: 3,
      title: 'Production',
      description: 'Using high-quality materials and advanced printing technology, we bring your designs to life.'
    },
    {
      step: 4,
      title: 'Installation',
      description: 'Our professional team handles the complete installation with safety protocols and quality checks.'
    }
  ]
};

// Form submission handler (mock)
export const submitQuoteForm = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Quote form submitted:', formData);
  
  // Mock success response
  return {
    success: true,
    message: 'Thank you for your inquiry! We will contact you within 24 hours.',
    quoteId: 'AIM' + Date.now()
  };
};

// Contact form submission (mock)
export const submitContactForm = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 800));
  
  console.log('Contact form submitted:', formData);
  
  return {
    success: true,
    message: 'Your message has been sent successfully! We will get back to you soon.'
  };
};